<template lang="pug">
.container-restricao
    div(
        v-if='restricoes.length > 0',
        :class='restricoes[index].inibido ? "camada-inibida" : ""',
        v-for='(restricao, index) in listaRestricoes'
    )
        slot(name='botaoInibir', :restricao='restricoes[index]')
        .card-restricao
            .container-restricao-acoes(
                v-if='habilitarZoomRestricao && (restricoes[index].geometry || restricoes[index].geometria || geometria)'
            )
                div
                    el-button(
                        size='small',
                        icon='mdi mdi-crosshairs-gps',
                        @click='aplicarZoomRestricao(index)'
                    )
            slot(name='selecionarRestricao', :restricao='restricoes[index]')
            .restricao-dados(
                v-for='({ label, value }, index) in listarRetricao(restricao)',
                :key='`$retricao-araa-embargada-pi-${index}`'
            )
                span.restricao-dados__label {{ `${label}:` }}
                span.restricao-dados__value {{ value }}

            Criticidade(v-if='restricao.nivelAlerta', :restricao='restricao')
</template>

<script>
import formatters from '@/utils/formatters';
import Criticidade from '@/components/diagnosticoSocioambiental/Criticidade.vue';
export default {
    name: 'area-embargada-rs',
    emits: ['highlightGeometry'],
    components: {
        Criticidade
    },
    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            restricao: []
        };
    },
    computed: {
        listaRestricoes: function () {
            return this.restricoes.map(value => {
                if (value.properties) {
                    return {
                        ...value.properties
                    };
                }
                return value;
            });
        }
    },
    methods: {
        listarRetricao(restricao) {
            return [
                {
                    label: this.$t(
                        'mensagens.diagnosticoSocioambiental.propriedadesCamada.codigo'
                    ),
                    value:
                        restricao?.codlist ||
                        restricao?.properties?.codlist ||
                        '-'
                },
                {
                    label: this.$t(
                        'mensagens.diagnosticoSocioambiental.propriedadesCamada.anoDesmatamento'
                    ),
                    value:
                        restricao?.ano_desmat ||
                        restricao?.properties?.ano_desmat ||
                        '-'
                },
                {
                    label: this.$t(
                        'mensagens.diagnosticoSocioambiental.propriedadesCamada.areaEmbargadaHa'
                    ),
                    value:
                        this.formatNumber(restricao?.embarg_ha) ||
                        this.formatNumber(restricao?.properties?.embarg_ha) ||
                        '-'
                },
                {
                    label: this.$t(
                        'mensagens.diagnosticoSocioambiental.propriedadesCamada.fonte'
                    ),
                    value:
                        restricao?.fonte || restricao?.properties?.fonte || '-'
                },
                {
                    label: this.$t(
                        'mensagens.diagnosticoSocioambiental.propriedadesCamada.municipio'
                    ),
                    value:
                        restricao?.municipio ||
                        restricao?.properties?.municipio ||
                        '-'
                },
                {
                    label: 'Status',
                    value:
                        restricao?.status ||
                        restricao?.properties?.status ||
                        '-'
                },
                {
                    label: this.$t(
                        'mensagens.diagnosticoSocioambiental.propriedadesCamada.dataAtualizacao'
                    ),
                    value:
                        restricao?.dt_geracao ||
                        restricao?.properties?.dt_geracao ||
                        '-'
                },
                {
                    label: this.$t(
                        'mensagens.diagnosticoSocioambiental.propriedadesCamada.numeroDoProcesso'
                    ),
                    value:
                        restricao?.p_semcar ||
                        this.calculaValorPcomcar(restricao)
                },
                {
                    label: this.$t(
                        'mensagens.diagnosticoSocioambiental.propriedadesCamada.car'
                    ),
                    value:
                        restricao?.num_car ||
                        restricao?.properties?.num_car ||
                        '-'
                }
            ];
        },
        aplicarZoomRestricao(index) {
            let geometriaQueNaoEstavaDentroDasRestricoes = null;
            if (this.geometria) {
                geometriaQueNaoEstavaDentroDasRestricoes =
                    this.geometria[index];
            }
            this.$emit(
                'aplicar-zoom-restricao',
                this.restricoes[index],
                geometriaQueNaoEstavaDentroDasRestricoes
            );
        },
        dataFormatada(data) {
            if (data && data.length > 0) {
                let ano = data.substring(0, 4);
                let mes = data.substring(5, 7);
                let dia = data.substring(8, 10);

                return dia + '/' + mes + '/' + ano;
            } else {
                return '-';
            }
        },
        calculaValorPcomcar(restricao) {
            const retorno = [
                restricao?.p_comcar,
                restricao?.properties?.p_comcar,
                restricao?.p_comcar_1,
                restricao?.properties?.p_comcar_1,
                restricao?.p_comcar_2,
                restricao?.properties?.p_comcar_2
            ];
            let textoPcomcar = '';
            retorno.map(valor => {
                if (valor) {
                    textoPcomcar += '\n' + valor;
                }
            });
            if (textoPcomcar.length > 0) return textoPcomcar;
            return '-';
        },
        calculaValorNumCar(restricao) {
            const retorno = [
                restricao?.num_car,
                restricao?.properties?.num_car,
                restricao?.num_car_2,
                restricao?.properties?.num_car_2,
                restricao?.num_car_3,
                restricao?.properties?.num_car_3,
                restricao?.num_car_4,
                restricao?.properties?.num_car_4,
                restricao?.num_car_5,
                restricao?.properties?.num_car_5,
                restricao?.num_car_6,
                restricao?.properties?.num_car_6
            ];
            let textoNumCar = '';
            retorno.map(valor => {
                if (valor) {
                    textoNumCar += '\n' + valor;
                }
            });
            if (textoNumCar.length > 0) return textoNumCar;
            return '-';
        },
        formatNumber(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2);
        },

        formatNumberPercent(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2) + '%';
        }
    }
};
</script>

<style lang="scss" scoped>
.restricao-dados {
    display: flex;
    gap: 3px;
    font-size: 13px;
    &__label {
        font-weight: bold;
    }
    &__value {
        display: inline-block;
        word-break: break-word;
    }
}
</style>
